const NONE = 'none'
const WHITE = 'white'
const TRANSLUCENT = 'translucent'
const NONE_WITH_BORDERS = 'none-with-borders'

export { NONE, WHITE, TRANSLUCENT, NONE_WITH_BORDERS }
